import { StrictMode, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import * as Sentry from "@sentry/react"

import App from "./App"
import AppErrorFallback from "./widgets/common/AppErrorFallback"
import Spinner from "./widgets/common/Spinner"
import { store } from "./features/store"
import { initMonitoring } from "./features/monitoring"
import { initEnvironmentBadge } from "./features/environmentBadge"
import { initStaleChunkRecovery } from "./helpers/utils/staleChunk"
import "./features/i18n"

initMonitoring()
initEnvironmentBadge()
initStaleChunkRecovery()

const container = document.getElementById("root") as HTMLElement
const root = createRoot(container)
root.render(
  <StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
        <Suspense fallback={<Spinner />}>
          <App />
        </Suspense>
      </Sentry.ErrorBoundary>
    </Provider>
  </StrictMode>,
)
